import { useMutation } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useDeleteActivityMutation = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await httpClient.delete(`/admin/activity/${id}`)
      return res.data
    },
    onSuccess: async () => {
      showSuccessNotification({
        title: "Deleted",
        message: "Successfully deleted activity",
      })
      queryClient.invalidateQueries({
        queryKey: ["findAllActivities"],
      })
    },
    onError: (error) => {
      showAxiosError({
        defaultMessage: "Failed to delete activity",
        showNotification: true,
        error,
      })
    },
  })
